import { createSlice } from "@reduxjs/toolkit";
import { message } from "antd";
import axios from "axios";
import Messages from "../../config/Message";
import {
  setIsRefreshingToken,
  setIsUnauthorise,
  setIsRestricted,
} from "./authSlice";

let failedQueue = [];

export const processFailedApiQueue = async (token = null) => {
  const retryPromises = failedQueue.map((req) => {
    req.headers["Authorization"] = `Bearer ${token}`; // Set the new token
    return axios(req);
  });
  await Promise.all(retryPromises);
  failedQueue = [];
};

// Slice
const interceptorSlice = createSlice({
  name: "api",
  initialState: {
    // failedQueue: []
  },
  reducers: {
    // processFailedApiQueue: (state, action) => {
    //   console.log("enter processFailedApiQueue");
    //   console.log("processFailedApiQueue action", action);
    //   const { error, token } = action.payload;
    //   console.log("failedQueue method", failedQueue);
    //   failedQueue.forEach((prom) => {
    //     if (error) {
    //       prom.reject(error);
    //     } else {
    //       prom.resolve(token);
    //     }
    //   });
    //   failedQueue = [];
    // },
  },
});

// export const { processFailedApiQueue } = interceptorSlice.actions;
export default interceptorSlice.reducer;

export const setAxiosInterceptor = (dispatch, getState) => {
  axios.interceptors.request.use(
    async (config) => {
      // dispatch(incrementLoading());
      let header = config.headers;
      header = {
        ...header,
        Timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      };
      const authToken = localStorage.getItem("token");
      // const authToken = "sdifbsdhfbsdf-sdfkjsbdkjfdjskfbdjksfdskjf";
      header = authToken
        ? {
            ...header,
            Accept: "application/json",
            Authorization: "Bearer " + authToken,
          }
        : {
            ...header,
            Accept: "application/json",
          };
      config.headers = header;
      return config;
    },
    (error) => {
      // dispatch(decrementLoading());
      return Promise.reject(error);
    }
  );

  axios.interceptors.response.use(
    (response) => {
      // dispatch(decrementLoading());
      if (response?.data?.notify) {
        message.success(response.data.notify);
      }
      return response;
    },
    (error) => {
      // dispatch(decrementLoading());
      if (error.response) {
        // if (e.response.data?.title) {
        //   message.error(e.response.data.title);
        // }
        // if (e.response.status === 423) {
        //     rootSlice.caseReducers.resetStore(state);
        // }
        // message.error(e.response?.data?.title || "An error occurred");
        // return Promise.reject(e.response);
        const originalRequest = error.config;

        let { isRefreshing, token } = getState().auth;
        if (error.response.status === 401) {
          if (token) {
            failedQueue.push(originalRequest);
            if (!isRefreshing) {
              dispatch(setIsRefreshingToken(true));
              dispatch(setIsUnauthorise(true));
              isRefreshing = true;
            }
          } else {
            message.error(error.response?.data?.title);
          }
        } else if (error.response.status === 500) {
          message.error(Messages().global.internalServer);
        } else if (error.response.status === 403) {
          // message.error(Messages().global.unauthorize);
          dispatch(setIsRestricted(true));
        } else if (error.response.status === 404) {
          message.error(Messages().global.notFound);
        }
        // console.log("e.response-----", error.response);

        return Promise.reject(error.response);
      } else {
        // Notification.error({ message: Messages().global.networkIssue });
        message.error(Messages().global.networkIssue);
        // return Promise.reject(error);
      }
    }
  );
};
